import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "@netiv/ui-core/src/tokens.css";
import "@netiv/ui-core/src/appShell.css";
import "@netiv/ui-core/src/components.css";
import "./styles.css";
import { invalidateStaleClientCaches } from "./cache-invalidation";
import { installGetResponseCache } from "./apiCache";

installGetResponseCache();
invalidateStaleClientCaches()
  .catch((error) => {
    console.warn("NETIV client cache invalidation failed", error);
  })
  .finally(() => {
    ReactDOM.createRoot(document.getElementById("root")!).render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
    );
  });
